
export const dataAperturaCaja = {
  codigo: "",
  usuario: "",
  fecha: "",
  estado: "",
  valorApertura: 0,
  valorCierre: 0,
  detalles: [{
    codigo: "",
    denominacion: "B100",
    valorApertura: 0,
    ValorCierre: 0,
  }, {
    codigo: "",
    denominacion: "B50",
    valorApertura: 0,
    ValorCierre: 0,
  }, {
    codigo: "",
    denominacion: "B20",
    valorApertura: 0,
    ValorCierre: 0,
  }, {
    codigo: "",
    denominacion: "B10",
    valorApertura: 0,
    ValorCierre: 0,
  }, {
    codigo: "",
    denominacion: "B5",
    valorApertura: 0,
    ValorCierre: 0,
  }, {
    codigo: "",
    denominacion: "B1",
    valorApertura: 0,
    ValorCierre: 0,
  }, {
    codigo: "",
    denominacion: "M100",
    valorApertura: 0,
    ValorCierre: 0,
  }, {
    codigo: "",
    denominacion: "M50",
    valorApertura: 0,
    ValorCierre: 0,
  }, {
    codigo: "",
    denominacion: "M25",
    valorApertura: 0,
    ValorCierre: 0,
  }, {
    codigo: "",
    denominacion: "M10",
    valorApertura: 0,
    ValorCierre: 0,
  }, {
    codigo: "",
    denominacion: "M5",
    valorApertura: 0,
    ValorCierre: 0,
  }, {
    codigo: "",
    denominacion: "M1",
    valorApertura: 0,
    ValorCierre: 0,
  }],
}